import { colorBrightness, colorToRgb } from 'reveal.js/js/utils/color'

export { storageGet, storageSet, storageRemove } from './storage'

export function getMetaValue(name) {
  const element = findElement(document.head, `meta[name="${name}"]`)
  if (element) {
    return element.getAttribute("content")
  }
}

export function findElement(root, selector) {
  if (typeof root == "string") {
    selector = root
    root = document
  }
  return root.querySelector(selector)
}

export function removeElement(el) {
  if (el && el.parentNode) {
    el.parentNode.removeChild(el)
  }
}

export function insertAfter(el, referenceNode) {
  return referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling)
}

export function capitalize(text) {
  return text.charAt(0).toUpperCase() + text.slice(1)
}

export function textContrastClass(backgroundColor) {
  const rgb = colorToRgb( backgroundColor )
  if( rgb && rgb.a !== 0 ) {
    if( colorBrightness( backgroundColor ) < 128 ) {
      return 'has-dark-background'
    }
    return 'has-light-background'
  }
}

export function validateJson(value) {
  try {
    JSON.parse(value)
    return true
  } catch (e) {
    console.error('Invalid JSON:', e)
    return false
  }
}

export function safeJsonParse(jsonString, defaultValue = null, errorContext = '') {
  try {
    return JSON.parse(jsonString)
  } catch (e) {
    const contextMessage = errorContext ? ` for ${errorContext}` : ''
    console.error(`Invalid JSON${contextMessage}:`, e)
    return defaultValue
  }
}

export function showFlashMessage(message, type = 'alert') {
  const template = document.getElementById('flash-message-template')
  if (!template) {
    console.warn('Flash message template not found. Falling back to console.error')
    console.error(message)
    return
  }

  const flashContent = template.content.cloneNode(true)
  const messageElement = flashContent.querySelector('[data-flash-message-text]')
  if (messageElement) {
    messageElement.textContent = message
  }

  const flashContainer = document.getElementById('flashes')
  if (flashContainer) {
    flashContainer.innerHTML = ''
    flashContainer.appendChild(flashContent)
  }
}

export async function responseErrors(response) {
  try {
    return await response.json
  } catch {
    return null
  }
}

export async function flashResponseError(response, fallback) {
  const data = await responseErrors(response)
  showFlashMessage(data?.errors?.join(', ') || fallback)
}
